import React, {useState, useEffect} from 'react';
import {useHistory, Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {DateTime} from 'luxon';
import {useTranslation} from 'react-i18next';
import {logoutUser} from '@store/reducers/auth';
import {Dropdown} from '@components';
import {nhanvienService} from "@app/services/nhanvienService";
import {capture_clearAll} from "@store/reducers/captureSlice";

const UserDropdown = () => {
    const history = useHistory();
    const [t] = useTranslation();
    const dispatch = useDispatch();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    let user = useSelector((state) => state.auth.currentUser);
    let userTmp = localStorage.getItem("profile");
    if(userTmp)
        user = JSON.parse(userTmp);


    const logOut = (event) => {
        event.preventDefault();
        setDropdownOpen(false);
        dispatch(logoutUser());
        dispatch(capture_clearAll());
        history.push('/login');
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDropdownOpen(false);
        history.push('/profile');
    };

    const initialNhanvien = {
        id: 0,
        dangnhap: '',
        ten: '',
        matkhau: '',
        dienthoai: '',
        diachi: '',
        email: '',
        trangthai: 1,
        loaifk: 3,
        quyenId: -1,
        nppIds:[],
        listKhoa:[]
    };
    const [nhanvien, setNhanvien] = useState(user);
    const [loading, setLoading] = useState(false);
    

    useEffect(async () => {
        setLoading(true);
       /* nhanvienService.getCurrentUser().then((response) => {
            //console.log('getById', JSON.stringify(response, null, 2));
            const userX = response.data.data;

            setNhanvien(userX);

        });*/


        setLoading(false);

    }, []);

    return (
        <Dropdown
            isOpen={dropdownOpen}
            onChange={(open) => setDropdownOpen(open)}
            className="user-menu"
            menuContainerTag="ul"
            buttonTemplate={
                <>
                {/*<img
                    src={user.picture || '/img/default-profile.png'}
                    className="user-image img-circle elevation-2"
                    alt="User"
                />
                    <p>

                    </p>*/}
                    <h5>{user.username}</h5>
                </>
            }
            menuTemplate={
                <>
                    <li className="user-header bg-primary">
                        <img
                            src={user.anhdaidien}
                            className="img-circle elevation-2"
                            alt="User"
                        />
                        <p>
                            {user.name }
                            <br/>
                            {user.username}
                            {/* <small>
                                <span>Member since </span>
                                <span>
                                    {DateTime.fromISO(user.createdAt).toFormat(
                                        'dd LLL yyyy'
                                    )}
                                </span>
                            </small> */}
                        </p>

                    </li>
                    {/* <li className="user-body">
                        <div className="row">
                            <div className="col-4 text-center">
                                <Link to="/">{t('header.user.followers')}</Link>
                            </div>
                            <div className="col-4 text-center">
                                <Link to="/">{t('header.user.sales')}</Link>
                            </div>
                            <div className="col-4 text-center">
                                <Link to="/">{t('header.user.friends')}</Link>
                            </div>
                        </div>
                    </li> */}
                    <li className="user-footer">
                        <button
                            type="button"
                            className="btn btn-default btn-flat"
                            onClick={navigateToProfile}
                        >
                            {t('header.user.profile')}
                        </button>
                        <button
                            type="button"
                            className="btn btn-default btn-flat float-right"
                            onClick={logOut}
                        >
                            {t('login.button.signOut')}
                        </button>
                    </li>
                </>
            }
        />
    );
};

export default UserDropdown;
